<template>
    <div class="button" @click="$emit('click', $event)">
        <Clickable>
            <div class="icon" v-if="icon">
                <fa-icon :icon="icon"></fa-icon>
            </div>
            <div class="content">
                <slot></slot>
            </div>
        </Clickable>
    </div>
</template>

<script>
    import Clickable from './Clickable';

    export default {
        props: {
            icon: String
        },
        data() {
            return {};
        },
        components: {
            Clickable
        }
    }
</script>

<style scoped lang="scss">
    .button {
        min-width: $space-256;
        
        color: white;
        background-color: $primaryColor;
        border-radius: $rounded-corners;
        box-shadow: $shadow-1;
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);

        &:hover {
            transform: translate(0, -$space-2);
            box-shadow: $shadow-2;
        }

        .icon {
            display: inline-block;
            margin: $space-8;
        }

        .content {
            display: inline-block;
            margin-top: $space-8;
            margin-bottom: $space-8;
            margin-right: $space-8;
        }
    }
</style>